// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root {
  font-family: 'Roboto';
  margin: 0;
  padding: 0;
}


h1, h2, h3, h4, h5, h6, p, span, button, input, textarea, a, li, div {
  font-family: inherit;
}


::-webkit-scrollbar {
  display: none;
}


html {
  scrollbar-width: none;
}


body {
  -ms-overflow-style: none; 
  overflow: auto;
  
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;;AAGA;EACE,oBAAoB;AACtB;;;AAGA;EACE,aAAa;AACf;;;AAGA;EACE,qBAAqB;AACvB;;;AAGA;EACE,wBAAwB;EACxB,cAAc;;AAEhB","sourcesContent":["html, body, #root {\n  font-family: 'Roboto';\n  margin: 0;\n  padding: 0;\n}\n\n\nh1, h2, h3, h4, h5, h6, p, span, button, input, textarea, a, li, div {\n  font-family: inherit;\n}\n\n\n::-webkit-scrollbar {\n  display: none;\n}\n\n\nhtml {\n  scrollbar-width: none;\n}\n\n\nbody {\n  -ms-overflow-style: none; \n  overflow: auto;\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
